import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";
import moment from "moment-timezone";
import Toggle from "material-ui/Toggle";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const WARNING_MSG = "Online ordering configurations is incorrect. Please contact the FreshBytes" +
    " support" +
    " team (support@freshbytes.io).";
export default class AutoAccept extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isAutoAcceptConfigEnabled:true,
            owAutoConfigEnabled:true,
            owDateTimeView:"",
            fields: {},
            errors: {},
            isLoaded: true,
            activeLocation:'',
            timeZone:'',
            startDate:this.loadLocationDateTime(),
            isFocusAutoacceptInput:false,
            isBtnDisabled:true,
            minDate:moment(),
            IsOpenAutoAccept:true,
            showAutoAcceptSettings: {}
        }

        this._bind(
            'handleChanged',
            'handleChangeToggleAutoAcceptConfig',
            'handleChangeToggleOwAutoConfig',
            'handleCancel',
            'loadLocationDateTime'
        );

        this.loadLocationDateTime();
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {
        this.loadAutoAcceptConfig();
    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadAutoAcceptConfig();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                },
                () => {
                    this.loadAutoAcceptConfig();
                });
        }
    }

    loadLocationDateTime(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);

        return moment();
    }

    loadAutoAcceptConfig() {

        let self = this;
        let activeLocation = this.state.activeLocation;

        let timeZone = Utils.extractTimeZoneFromLocation(activeLocation);
        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        let defaultFromDate = new Date(currentDateTime);

        if (!Utils.isEmptyObj(activeLocation)) {

            let pvtConfig = activeLocation.pvtConfig;
            let locationConfig = activeLocation.locationConfig;
            let deliveryInfo = activeLocation.deliveryInfo;

            if(!Utils.isEmptyObj(locationConfig)){

                // check if pickUp order is enabled / disabled.
                let isPickUpDisabled   =  locationConfig.hasOwnProperty("disablePickUp") ? locationConfig.disablePickUp : false;

                let autoAcceptSettings = {};

                if(isPickUpDisabled == true && Utils.isEmptyObj(deliveryInfo)) {
                    //if pickUporder disabled and deliveryInfo not present
                    //show wrong congfig message
                    autoAcceptSettings["hideAutoAcceptSettings"] = true;
                }
                else if(isPickUpDisabled == false && Utils.isEmptyObj(deliveryInfo)){
                    //if pickUporder enabled and deliveryInfo not present
                    autoAcceptSettings["optionalDeliveryAcceptSettings"] = true;
                }
                else if(isPickUpDisabled == true && !Utils.isEmptyObj(deliveryInfo)){
                    //if pickUporder disabled and deliveryInfo is present
                    autoAcceptSettings["optionalPickUpAcceptSettings"] = true;
                }

                this.setState({showAutoAcceptSettings:  autoAcceptSettings })

            }

            if (!Utils.isEmptyObj(pvtConfig)) {

                let autoConfig = pvtConfig.autoConfig;

                // let delayInSec = "";
                let readyForPickUpMin = "";
                let outForDeliveryMin = "";

                let defaultAutoConfig = false;
                if (!Utils.isEmptyObj(autoConfig)) {
                    defaultAutoConfig = true;

                    // delayInSec = autoConfig.delayInSec;
                    readyForPickUpMin = autoConfig.readyForPickUpMin;
                    outForDeliveryMin = autoConfig.outForDeliveryMin;
                }

                let owAutoConfig = pvtConfig.owAutoConfig;

                let owAutoConfigDefault = false;
                let owReadyForPickUpMin = "";
                let owOutForDeliveryMin = "";
                let dateFromLT;
                let owDateTime = defaultFromDate;

                if (!Utils.isEmptyObj(owAutoConfig)) {


                    let stopOwUntil = owAutoConfig.validUntil.iso;
                    dateFromLT = Utils.formatDateTimeWithTimeZone(new Date(stopOwUntil),timeZone);
                    let dateFromLTObject = new Date(dateFromLT);

                    if(defaultFromDate.getTime() > dateFromLTObject.getTime()){
                        owAutoConfigDefault = false;
                        owDateTime = dateFromLTObject
                    }
                    else {
                        owAutoConfigDefault = true;
                        owDateTime= dateFromLTObject;
                    }

                    owReadyForPickUpMin = owAutoConfig.readyForPickUpMin;
                    owOutForDeliveryMin = owAutoConfig.outForDeliveryMin;
                }

                var dateObj = new Date(owDateTime);
                let formattedDateTime = Utils.formatDateTimeWithTimeZone(dateObj);

                self.setState({
                    timeZone:timeZone,
                    isAutoAcceptConfigEnabled:defaultAutoConfig,
                    owAutoConfigEnabled:owAutoConfigDefault,
                    // owDateTimeView:formattedDateTime,
                    // startDate: null,
                    fields: {
                        readyForPickUpMin: readyForPickUpMin,
                        outForDeliveryMin: outForDeliveryMin,
                        owReadyForPickUpMin: owReadyForPickUpMin,
                        owOutForDeliveryMin: owOutForDeliveryMin
                    },
                });

                if(this.state.owAutoConfigEnabled == false ){
                    self.setState({
                        owDateTimeView:"",
                        isFocusAutoacceptInput:true,
                        IsOpenAutoAccept:true
                    })
                }else{
                    self.setState({
                        startDate: null,
                        owDateTimeView:formattedDateTime,
                        isFocusAutoacceptInput:true,
                        IsOpenAutoAccept:true
                    })
                }

            } else {
                self.setState({
                    isAutoAcceptConfigEnabled:false,
                    owAutoConfigEnabled:false,
                    timeZone:timeZone,
                    minOwDate:defaultFromDate,
                    // owDateTimeView:""
                });
            }
        }

    }

    handleChange(field, e){

        let fields = this.state.fields;
        fields[field] = e.target.value;

        this.setState({fields, isBtnDisabled:false});
    }

    handleChangeToggleAutoAcceptConfig = (event, eventValue) => {

        this.setState({
            isAutoAcceptConfigEnabled: eventValue,
            isBtnDisabled: false,
            errors:""
        });

    };

    handleChangeToggleOwAutoConfig = (event, eventValue) => {
        this.setState({
            owAutoConfigEnabled: eventValue,
            isBtnDisabled:false,
            errors:""
        });

        this.handleResetDate();
    };

    handleResetDate() {
        if(this.state.owAutoConfigEnabled == true){
            this.setState({
                startDate: null,
                isFocusAutoacceptInput:true,
                isBtnDisabled:false,
                errors:""
                // owDateTimeView:''
            });
        }else{
            this.setState({
                errors:"",
                isBtnDisabled:false,
                isFocusAutoacceptInput:true
            })
        }
    };

    handleValidation(){

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        let showAutoAcceptSettings = this.state.showAutoAcceptSettings;

        if (this.state.isAutoAcceptConfigEnabled == true){
            //readyForPickUpMin
            if(!showAutoAcceptSettings.hasOwnProperty("optionalPickUpAcceptSettings") && !fields["readyForPickUpMin"]){
                formIsValid = false;
                errors["readyForPickUpMin"] = "Cannot be empty";

                this.setState({
                    errors: errors
                }, () => {
                    Utils.scrollToTop("readyForPickUpMinBox");
                });

                return formIsValid;
            }
            //outForDeliveryMin
            else if(!showAutoAcceptSettings.hasOwnProperty("optionalDeliveryAcceptSettings") && !fields["outForDeliveryMin"]){
                formIsValid = false;
                errors["outForDeliveryMin"] = "Cannot be empty";

                this.setState({
                    errors: errors
                }, () => {
                    Utils.scrollToTop("outForDeliveryMinBox");
                });

                return formIsValid;
            }
            else if(this.state.owAutoConfigEnabled == true){

                let owDateTime = this.state.startDate;
                //readyForPickUpMin
                if(!showAutoAcceptSettings.hasOwnProperty("optionalPickUpAcceptSettings") && !fields["owReadyForPickUpMin"]){
                    formIsValid = false;
                    errors["owReadyForPickUpMin"] = "Cannot be empty";
                    this.setState({
                        errors: errors
                    }, () => {
                        Utils.scrollToTop("owReadyForPickUpMinBox");
                    });
                    return formIsValid;
                }
                //outForDeliveryMin
                else if(!showAutoAcceptSettings.hasOwnProperty("optionalDeliveryAcceptSettings") && !fields["owOutForDeliveryMin"]){
                    formIsValid = false;
                    errors["owOutForDeliveryMin"] = "Cannot be empty";
                    this.setState({
                        errors: errors
                    }, () => {
                        Utils.scrollToTop("owOutForDeliveryMinBox");
                    });
                    return formIsValid;
                }
                else if(Utils.isEmpty(owDateTime)){
                    formIsValid = false;
                    errors["errors"] = "Date & Time is required";
                    this.setState({
                        errors: errors
                    }, () => {
                        Utils.scrollToTop("error-container");
                    });
                    return formIsValid;
                }

            }
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    getUTCDateTimeJSONFromSelectedDateTime(startDateTime){
        // moment.tz.setDefault(this.state.timeZone);
        var format = 'YYYY/MM/DD HH:mm:ss';
        var dateStringWithTime = moment(startDateTime).format(format);

        var utcDateTime = moment(dateStringWithTime, format).tz("UTC").format();


        return Utils.getDateJson(utcDateTime);

    }

    updateLocationFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;

            let self = this;
            self.setState({
                isLoaded : false,
                errors: {}
            });

            let fields = this.state.fields;

            let readyForPickUpMin = "";
            let outForDeliveryMin = "";

            let autoConfigObject = {};

            if (this.state.isAutoAcceptConfigEnabled == true){
                if(!Utils.isEmpty(fields["readyForPickUpMin"]) || !Utils.isEmpty(fields["outForDeliveryMin"])){
                    // delayInSec = fields["delayInSec"];
                    readyForPickUpMin = fields["readyForPickUpMin"];
                    outForDeliveryMin = fields["outForDeliveryMin"];

                    autoConfigObject = {
                        "delayInSec" : 60, // default 60 sec
                        ...(!Utils.isEmpty(readyForPickUpMin) && {readyForPickUpMin : readyForPickUpMin}),
                        ...(!Utils.isEmpty(outForDeliveryMin) && {outForDeliveryMin : outForDeliveryMin})
                    };
                }
            }

            let owReadyForPickUpMin = "";
            let owOutForDeliveryMin = "";

            let owAutoConfigObject = {};
            if (this.state.owAutoConfigEnabled == true){
                if(!Utils.isEmpty(fields["owReadyForPickUpMin"]) || !Utils.isEmpty(fields["owOutForDeliveryMin"])){
                    // delayInSec = fields["delayInSec"];
                    owReadyForPickUpMin = fields["owReadyForPickUpMin"];
                    owOutForDeliveryMin = fields["owOutForDeliveryMin"];

                    let owDateTime = this.state.startDate;
                    // let owTime = this.state.owTime;

                    let stopOwUntilJSON = self.getUTCDateTimeJSONFromSelectedDateTime(owDateTime);

                    owAutoConfigObject = {
                        "validUntil":stopOwUntilJSON,
                        ...(!Utils.isEmpty(owReadyForPickUpMin) && {readyForPickUpMin: owReadyForPickUpMin}),
                        ...(!Utils.isEmpty(owOutForDeliveryMin) && {outForDeliveryMin : owOutForDeliveryMin})
                    };
                }
            }

            let parameterObject = {};
            let pvtConfig = activeLocation.pvtConfig;

            if (!Utils.isEmptyObj(pvtConfig)) {
                // create the copy object of pvtConfig
                let pvtConfigCopy = pvtConfig;

                // check if the autoConfig is not empty then set the value
                // Otherwise remove the autoConfig key in pvt config
                if (this.state.isAutoAcceptConfigEnabled == true){
                    pvtConfigCopy["autoConfig"] = autoConfigObject;

                    if (this.state.owAutoConfigEnabled == true){
                        pvtConfigCopy["owAutoConfig"] = owAutoConfigObject;
                    }
                    else {
                        // removed the "owAutoConfig" from the pvtConfig object
                        const { owAutoConfig, ...withoutOwAutoConfig } = pvtConfigCopy;
                        // assign to the pvtconfig object
                        pvtConfigCopy = withoutOwAutoConfig;
                    }
                }
                else {
                    // removed the "autoConfig" from the pvtConfig object
                    const { autoConfig, ...withoutAutoConfig } = pvtConfigCopy;
                    const { owAutoConfig, ...withoutOwAutoConfig } = withoutAutoConfig;
                    // assign to the pvtconfig object
                    pvtConfigCopy = withoutOwAutoConfig;

                }

                parameterObject["pvtConfig"] = pvtConfigCopy;

            } else {

                if (this.state.isAutoAcceptConfigEnabled == true){
                    parameterObject["pvtConfig"] = {};

                    parameterObject["pvtConfig"]["autoConfig"] = autoConfigObject;

                    if (this.state.owAutoConfigEnabled == true){
                        parameterObject["pvtConfig"]["owAutoConfig"] = owAutoConfigObject;
                    }

                }
            }

            // add the location id in objectId key
            parameterObject["objectId"] = locId;

            this.updatePvtConfig(parameterObject);
        }
    }


    updatePvtConfig(paramsObject){

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;
        let self = this;

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Auto accept config are updated successfully.");

                    self.setState({
                        isLoaded: true,
                        isBtnDisabled:true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );
    }


    handleChanged(date) {
        this.showOwDateTimeView(moment(date,this.state.timeZone));

        let newDate = date.format('MM-DD-YYYY');
        let currentDayDate = moment().format('MM-DD-YYYY');

         //return true if selected date is same as today
        if(moment(newDate).isSame(currentDayDate)){
            this.setState({
                IsOpenAutoAccept:true,
                isBtnDisabled:false
            })
        }else{
            this.setState({
                IsOpenAutoAccept:false,
                isBtnDisabled:false
            })
        }
    }


    showOwDateTimeView(momentDateTime){

        if (this.state.owAutoConfigEnabled == true){

            this.setState({
                startDate: momentDateTime,
            })
        }

    };

    handleCancel(){
        this.props.reloadLocation();
        this.setState({
            errors:"",
            isBtnDisabled:true
        });
    };

    renderAutoAcceptSettings(){

        let showAutoAcceptSettings = this.state.showAutoAcceptSettings;
        let optionalPickUpSettings = showAutoAcceptSettings.hasOwnProperty("optionalPickUpAcceptSettings") ? showAutoAcceptSettings["optionalPickUpAcceptSettings"] : false;
        let optionalDeliveryAcceptSettings = showAutoAcceptSettings.hasOwnProperty("optionalDeliveryAcceptSettings") ? showAutoAcceptSettings["optionalDeliveryAcceptSettings"] : false;

        return(
            <form name="updateLocationForm" className="updateLocationForm" onSubmit= {this.updateLocationFormSubmit.bind(this)}>

                <div className="row form-group">
                    <div className="col-lg-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Auto Accept Settings</label>
                            <Toggle
                                id={"isAutoAcceptConfigEnabled"}
                                defaultToggled={this.state.isAutoAcceptConfigEnabled}
                                onToggle={this.handleChangeToggleAutoAcceptConfig}
                                style={{marginTop: 5, width:'100px'}}
                                thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                            />


                        </div>
                    </div>

                </div>

                {
                    this.state.isAutoAcceptConfigEnabled == true ? (
                        <div className="row form-group">

                            <div className="col-lg-6" id={"readyForPickUpMinBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName">{`Ready For PickUp (${!optionalPickUpSettings ? "Minutes": "Optional"})`}</label>
                                    <input type="number" className="form-control" id="readyForPickUpMin" ref="readyForPickUpMin"
                                           aria-describedby="readyForPickUpMin"
                                           placeholder="Ready For PickUp (Minutes)"
                                           onChange={this.handleChange.bind(this, "readyForPickUpMin")}
                                           value={this.state.fields["readyForPickUpMin"]}
                                    />
                                            <span style={{color: "red"}} className="form-text">{this.state.errors["readyForPickUpMin"]}
                                    </span>
                                </div>
                            </div>


                            <div className="col-lg-6" id={"outForDeliveryMinBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName">{`Out For Delivery (${!optionalDeliveryAcceptSettings ? "Minutes": "Optional"})`}</label>
                                    <input type="number" className="form-control" id="outForDeliveryMin" ref="outForDeliveryMin"
                                       aria-describedby="outForDeliveryMin"
                                           placeholder="Out For Delivery (Minutes)"
                                           onChange={this.handleChange.bind(this, "outForDeliveryMin")}
                                           value={this.state.fields["outForDeliveryMin"]}
                                    />
                                        <span style={{color: "red"}} className="form-text">{this.state.errors["outForDeliveryMin"]}
                                    </span>
                                </div>
                            </div>

                        </div>
                    ) : null
                }

                {
                    this.state.isAutoAcceptConfigEnabled == true ? (
                        <div className="row form-group">
                            <div className="col-lg-6">
                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1">Temporarily Change Auto Accept Settings</label>
                                    <Toggle
                                        id={"owAutoConfigEnabled"}
                                        defaultToggled={this.state.owAutoConfigEnabled}
                                        onToggle={this.handleChangeToggleOwAutoConfig}
                                        style={{marginTop: 5, width:'100px'}}
                                        thumbSwitchedStyle={{ backgroundColor: '#008000'}}
                                        trackSwitchedStyle={{ backgroundColor: '#8fbc8f'}}
                                    />
                                </div>
                            </div>

                        </div>
                    ) : null
                }

                {
                    this.state.isAutoAcceptConfigEnabled == true && this.state.owAutoConfigEnabled == true ? (
                        <div className="row">

                            <div className="col-lg-6" id={"owReadyForPickUpMinBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName">{`Ready For PickUp (${!optionalPickUpSettings ? "Minutes": "Optional"})`}</label>
                                    <input type="number" className="form-control" id="owReadyForPickUpMin" ref="owReadyForPickUpMin"
                                           aria-describedby="owReadyForPickUpMin"
                                           onChange={this.handleChange.bind(this, "owReadyForPickUpMin")}
                                           value={this.state.fields["owReadyForPickUpMin"]}
                                           placeholder="Ready For PickUp (Minutes)"
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["owReadyForPickUpMin"]}
                                </span>
                                </div>
                            </div>

                            <div className="col-lg-6" id={"owOutForDeliveryMinBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName">{`Out For Delivery (${!optionalDeliveryAcceptSettings ? "Minutes" : "Optional"})`}</label>
                                    <input type="number" className="form-control" id="owOutForDeliveryMin" ref="owOutForDeliveryMin"
                                           aria-describedby="owOutForDeliveryMin"
                                           placeholder="Out For Delivery (Minutes)"
                                           onChange={this.handleChange.bind(this, "owOutForDeliveryMin")}
                                           value={this.state.fields["owOutForDeliveryMin"]}
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["owOutForDeliveryMin"]}
                                    </span>
                                </div>
                            </div>


                            <div className="col-lg-12">
                                <label htmlFor="labelName"> Please Select the Date & Time for auto-accept Settings</label><br />
                                {
                                    this.state.owDateTimeView ? (

                                        <h5>
                                            Valid Until {this.state.owDateTimeView}
                                        </h5>

                                    ) : null
                                }

                                <i className="fa fa-autoaccept fa-calendar"></i>
                                <div className="autoaccept-input">
                                    <DatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleChanged}
                                        minDate={moment()}
                                        minTime={this.state.IsOpenAutoAccept ? moment() : moment().add(1, 'days').set({h: 0, m: 0}) }
                                        maxTime={moment().set({h: 23, m: 45})}
                                        wrapperClassName="react-datepicker-wrapper autoaccept-input"
                                        showTimeSelect
                                        dateFormat="LLL"
                                        shouldCloseOnSelect={true}
                                        title="Choose the date time"
                                        placeholderText={"Choose the Date Time"}
                                        timeIntervals={30}
                                        autoFocus={this.state.isFocusAutoacceptInput}
                                        onChangeRaw={(e) => e.preventDefault()}
                                    >
                                        <div className="title-container-new align-items-center justify-content-center">

                                            {this.state.owDateTimeView  ? (
                                                <div>
                                                    <span className="online-ordering-until"><b>Autoaccept configs are enabled Until</b> <br /></span>
                                                    <span className="Online-dateTime-view">{this.state.owDateTimeView}</span>
                                                </div>

                                            ) : <div className="container-datetime">
                                                <span> Choose the Date & Time</span>
                                            </div>
                                            }

                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                    ) : null
                }

                <hr></hr>

                <div className="form-group">
                    <button type="submit" className={this.state.isBtnDisabled ? "btn-save btn btn-export" : "btn btn-export"}>Save</button>
                    <button type="button" className="btn btn-default back-button"
                            onClick={this.handleCancel}>Cancel
                    </button>
                </div>
                <hr></hr>
            </form>
        )
    }


    render() {

        let showAutoAcceptSettings = this.state.showAutoAcceptSettings;

        return (
            <div className="auto-accept">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert" id={"error-container"}>
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                        <div className="border-class marginTop">

                            <h4 id="translations" className="page-header">Auto Accept Settings
                                <br/>
                                <small className="form-text text-muted">When enabled our system will automatically accept the order and notify customer the pick up and delivery time configured here. It is mandatory to enable it when using OrderMark, Otter or Covid service.</small>
                            </h4>

                            {
                                showAutoAcceptSettings.hasOwnProperty("hideAutoAcceptSettings") && showAutoAcceptSettings["hideAutoAcceptSettings"] == true  ? (
                                    <span className={"text-red text-left ft-14"}>{WARNING_MSG}</span>
                                ) : this.renderAutoAcceptSettings()
                            }


                        </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/auto-accept.js